import styled from 'styled-components';

// Exact preview geometry: a 3px solid rule meeting straight, filled 11px tips.
const Rule = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 14px;
  color: ${({ theme }) => theme.color.textMuted};
  opacity: 0.5;
  pointer-events: none;

  svg {
    width: 12px;
    height: 14px;
    flex: 0 0 12px;
    fill: currentColor;
    stroke: none;
  }

  span {
    flex: 1;
    height: 3px;
    background: currentColor;
  }
`;

export function ActionDivider() {
  return (
    <Rule aria-hidden="true">
      <svg viewBox="0 0 12 14" width="12" height="14" focusable="false">
        <path d="M12 5.5 L1 7 L12 8.5 Z" />
      </svg>
      <span />
      <svg viewBox="0 0 12 14" width="12" height="14" focusable="false">
        <path d="M0 5.5 L11 7 L0 8.5 Z" />
      </svg>
    </Rule>
  );
}
